import * as React from 'react';
import { OfferingType } from 'Core/Api/Api';
import { Row, Col, Button, Divider, Modal } from 'antd';
import GiftRecipientFormModel from './GiftRecipientFormModel';
import GiftRecipientEditor from './GiftRecipientEditor';
import { ClientIpoHandler } from 'components/Client/ClientIpoHandler';
import NotificationService from 'Core/NotificationService';
import { GiftRecipientTable, AllocationTotalView } from '.';
import DetailsMode from 'Core/models/DetailsMode';
import numeral from 'numeral';

export interface Props {
    children?: React.ReactNode;
    value?: GiftRecipientFormModel[];
    offeringId?: string;
    onChange?: (data: GiftRecipientFormModel[]) => void;
    mode?: DetailsMode;
    totalAllocation?: number;
    offeringType?: OfferingType;
    sharePoolName?: string;
}

export interface State {
    showEditor: boolean;
    currentSharePool?: GiftRecipientFormModel;
    editorOnChangeMethod?: (giftRecipient: GiftRecipientFormModel) => void;
}

export default class GiftRecipientDetailsForm extends React.Component<Props, State> {
    static defaultProps: Props = {
        mode: DetailsMode.New,
    };

    handler: ClientIpoHandler;

    constructor(props: Props) {
        super(props);

        this.state = {
            showEditor: false,
            editorOnChangeMethod: this.onSharePoolChangedForNewDetailsMode,
        };
        this.handler = new ClientIpoHandler(props);
    }

    componentDidUpdate = (prevProps: Props) => {
        if (this.props.mode != prevProps.mode) {
            if (!this.props.mode || this.props.mode == DetailsMode.New) {
                this.setState({ editorOnChangeMethod: this.onSharePoolChangedForNewDetailsMode });
            } else {
                this.setState({ editorOnChangeMethod: this.onSharePoolChangedForEditDetailsMode });
            }
        }
    };

    onDeleteSharePool = (giftRecipient: GiftRecipientFormModel) => {
        const updatedSharePools = [
            ...(this.props.value?.filter(x => x.jcsdNumber !== giftRecipient.jcsdNumber) ?? []),
        ];

        if (this.props.onChange) {
            this.props.onChange(updatedSharePools);
        }

    };

    addEditSharePool = (sharePool?: GiftRecipientFormModel) => {
        const newSharePool = sharePool ?? new GiftRecipientFormModel(true);

        this.setState({ showEditor: true, currentSharePool: newSharePool });
    };

    onSharePoolChangedForEditDetailsMode = (giftRecipient: GiftRecipientFormModel) => {
        console.log("onSharePoolChangedForEditDetailsMode");
        if (giftRecipient.isNew) {
            Modal.confirm({
                title: `Add ${giftRecipient.jcsdNumber}`,
                content: `This will gift "${giftRecipient.jcsdNumber}" ${giftRecipient.numberOfShares} shares, are you sure you want to continue?`,
                okText: 'Continue',
                cancelText: 'Cancel',
                onOk: () => this.addNewSharePoolToOffering(giftRecipient),
            });
        } else {
            console.log('Not implemented');
            Modal.confirm({
                title: `Update ${giftRecipient.jcsdNumber}`,
                content: `This will gift "${giftRecipient.jcsdNumber}" ${giftRecipient.numberOfShares} shares, are you sure you want to continue?`,
                okText: 'Continue',
                cancelText: 'Cancel',
                onOk: () => this.updateSharePoolToOffering(giftRecipient),
            });
        }
    };

    updateSharePoolToOffering = (giftRecipient: GiftRecipientFormModel) => {
        console.log("updateSharePoolToOffering");
        //const model: IWebSharePoolModel = {
        //    allocation: giftRecipient.allocation,
        //    name: giftRecipient.name,
        //    id: giftRecipient.id,
        //    offeringId: this.props.offeringId,
        //    price: giftRecipient.price,
        //    verificationLabel: giftRecipient.verificationLabel,
        //    verificationList: giftRecipient.verificationList as any,
        //    requireVerification: giftRecipient.requireVerification,
        //    appType: giftRecipient.appType,
        //    batchNumber: giftRecipient.batchNumber,
        //    offeringType: this.props.offeringType

        //};
        //this.handler
        //    .EditSharePool(model)
        //    .then(this.UpdateSharePoolList)
        //    .then(x => {
        //        this.setState({ showEditor: false, currentSharePool: undefined });
        //        NotificationService.success(`${giftRecipient.name} Updated`);
        //    });
    };

    addNewSharePoolToOffering = (giftRecipient: GiftRecipientFormModel) => {
        //const model: GiftRecipientFormModel = {
            
        //    name: giftRecipient.name,
        //    offeringId: this.props.offeringId,
        //    price: giftRecipient.price,
        //    verificationLabel: giftRecipient.verificationLabel,
        //    verificationList: giftRecipient.verificationList as any,
        //    requireVerification: giftRecipient.requireVerification,
        //    appType: giftRecipient.appType,
        //    batchNumber: giftRecipient.batchNumber,
        //    offeringType: this.props.offeringType
        //};

        console.log("addNewSharePoolToOffering");
        console.log(giftRecipient);
        //this.handler
        //    .CreateSharePool(model)
        //    .then(this.UpdateSharePoolList)
        //    .then(x => {
        //        this.setState({ showEditor: false, currentSharePool: undefined });
        //        NotificationService.success(`${giftRecipient.jcsdNumber} Added`);
        //    });
    };

    //UpdateSharePoolList = sharePool => {
    //    return this.handler.GetSharePoolsByOfferingId(this.props.offeringId!).then(x => {
    //        this.props.onChange?.call(this, x.sharePools ?? []);
    //        return sharePool;
    //    });
    //};

    onSharePoolChangedForNewDetailsMode = (giftRecipient: GiftRecipientFormModel) => {
        console.log('triggered 2');
        console.log(giftRecipient);

        const filteredSharePool = this.props.value?.filter(x => giftRecipient.jcsdNumber && x.jcsdNumber == giftRecipient.jcsdNumber);
        let updatedSharePools;
        if (filteredSharePool && filteredSharePool.length) {
            console.log('b');
            const listwithOldSharePool = this.props.value?.filter(x => x !== filteredSharePool[0]) ?? [];
            updatedSharePools = [...(listwithOldSharePool ?? []), giftRecipient];
        } else if (giftRecipient.isNew) {
            console.log('b');
            updatedSharePools = [
                ...(this.props.value?.filter(x => x.key !== giftRecipient.key) ?? []),
                giftRecipient,
            ];
        }
        console.log(updatedSharePools);

        if (this.props.onChange) {
            this.props.onChange(updatedSharePools);
        }
        this.setState({ showEditor: false, currentSharePool: undefined });
    };

    getTotalAllocation = () => {
        var total = 0;
        try {
            this.props.value?.forEach(
                x => (total = (total as number) + numeral(x.numberOfShares! as any).value())
            );
            return total;
        } catch {
            return 0;
        }
    };

    onCancelUpdate = () => {
        this.setState({ currentSharePool: undefined, showEditor: false });
    };

    render() {
        return (
            <Row>
                <Col span={24}>
                    <Row>
                        <AllocationTotalView
                            sharePoolTotals={this.getTotalAllocation()}
                            totalAllocation={numeral(this.props.totalAllocation).value()}
                            sharePoolName={this.props.sharePoolName}
                        />
                    </Row>
                    <Row>
                        {!this.state.showEditor && (
                            <Button onClick={() => this.addEditSharePool()} type="default">
                                Add Recipient
                            </Button>
                        )}
                    </Row>
                    <Row>
                        <GiftRecipientTable
                            onEdit={this.addEditSharePool}
                            onDelete={this.onDeleteSharePool}
                            value={this.props.value}
                        />
                    </Row>
                    <Row>                        
                        {this.state.showEditor && (
                            <GiftRecipientEditor
                                offeringType={this.props.offeringType}
                                mode={this.props.mode}
                                onCancel={this.onCancelUpdate}
                                onChange={this.state.editorOnChangeMethod}
                                value={this.state.currentSharePool}
                            />
                        )}
                    </Row>
                </Col>
            </Row>
        );
    }
}
